import { render, staticRenderFns } from "./DurationRenderer.vue?vue&type=template&id=44645a4b&scoped=true"
import script from "./DurationRenderer.vue?vue&type=script&lang=js"
export * from "./DurationRenderer.vue?vue&type=script&lang=js"
import style0 from "./DurationRenderer.vue?vue&type=style&index=0&id=44645a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44645a4b",
  null
  
)

export default component.exports